import { useEffect, useState } from 'react';
import { Button } from '@/components/ui';
import {
  COOKIE_CONSENT_ALLOW_VALUE,
  COOKIE_CONSENT_KEY,
  getStoredStringValue,
  setStoredStringValue,
} from '@/utils/pwaStorage';

export const CookieConsentHandler = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      const cookieConsent = getStoredStringValue(COOKIE_CONSENT_KEY);
      if (cookieConsent !== COOKIE_CONSENT_ALLOW_VALUE) {
        setIsVisible(true);
      }
    }, 0);

    return () => {
      window.clearTimeout(timerId);
    };
  }, []);

  const submitCookieConsent = () => {
    setStoredStringValue(COOKIE_CONSENT_KEY, COOKIE_CONSENT_ALLOW_VALUE);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-1/2 z-50 w-[90vw] max-w-4xl -translate-x-1/2 rounded-lg border border-gray-200 bg-white p-4 shadow-lg dark:border-dark-700 dark:bg-dark-800">
      <div className="flex flex-col items-center gap-3 text-center lg:flex-row lg:justify-between lg:text-left">
        <p className="text-sm text-gray-700 dark:text-gray-200">
          Please read our disclaimer about this service. We only use cookies strictly required for
          good functionality of our website. By using our site, you consent cookies and agree with
          the disclaimer.{' '}
          <a
            href="/"
            className="font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300"
          >
            Learn more.
          </a>
        </p>
        <Button onClick={submitCookieConsent} size="sm">
          ACCEPT
        </Button>
      </div>
    </div>
  );
};
